import ReactGA from 'react-ga4';

type EventParams = Record<string, unknown> & {
  category?: string;
  label?: string;
  value?: number | string;
  nonInteraction?: boolean;
};

export const trackPageView = (path: string, title?: string) => {
  if (!ReactGA.isInitialized) return;
  ReactGA.send({ hitType: 'pageview', page: path, title });
};

export const trackEvent = (action: string, params: EventParams = {}) => {
  if (!ReactGA.isInitialized) return;
  ReactGA.event(action, params);
};
